/**
 * ProductImage DTO - a single image of a product gallery.
 */
export class ProductImage {
  constructor(data = {}) {
    this.id = data.id || null;
    this.position = data.position !== undefined && data.position !== null ? data.position : 0;
    this.isPrimary = data.isPrimary !== undefined ? Boolean(data.isPrimary) : false;
    this.imageThumbUrl = data.imageThumbUrl || null;
    this.imageCardUrl = data.imageCardUrl || null;
    this.imageDetailUrl = data.imageDetailUrl || null;
  }

  /**
   * Creates a ProductImage from a JSON object.
   * @param {Object} json
   * @returns {ProductImage}
   */
  static fromJSON(json) {
    if (!json) {
      return null;
    }

    return new ProductImage({
      id: json.id,
      position: json.position,
      isPrimary: json.isPrimary,
      imageThumbUrl: json.imageThumbUrl,
      imageCardUrl: json.imageCardUrl,
      imageDetailUrl: json.imageDetailUrl,
    });
  }

  /**
   * Best available URL for previews, preferring the card variant.
   * @returns {string|null}
   */
  getPreviewUrl() {
    return this.imageCardUrl || this.imageDetailUrl || this.imageThumbUrl || null;
  }

  toJSON() {
    return {
      id: this.id,
      position: this.position,
      isPrimary: this.isPrimary,
      imageThumbUrl: this.imageThumbUrl,
      imageCardUrl: this.imageCardUrl,
      imageDetailUrl: this.imageDetailUrl,
    };
  }
}
